<template>
  <div :class="[b(), className]" :style="styleSizeName">
    <div :ref="id" :style="styleChartName">
      <ul class="flow-list">
        <li
          :class="[
            'flow-subList',
            (index + 1) % 2 === 0 ? 'flex-reverse' : 'flex-normal',
          ]"
          v-for="(subList, index) in formatData"
          :key="index"
        >
          <div
            :class="['flow-item', subIndex === 2 && 'flow-down']"
            v-for="(item, subIndex) in subList"
            :key="item.value"
          >
            <div
              :class="!!item.status ? 'item-select' : 'item-normal'"
              :style="{
                'font-size': fontSize + 'px',
                'font-color': fontColor,
              }"
            >
              {{ item.value }}
            </div>
            <div
              :class="subIndex === 2 ? 'arrow-down' : 'arrow-item'"
              v-if="
                !(
                  index === formatData.length - 1 &&
                  subIndex === subList.length - 1
                )
              "
            >
              <div class="arrow-line"></div>
              <img class="arrow-icon" :src="arrowIcon" alt="" />
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import arrowIcon from "@/assets/img/arrowRight.png";
export default {
  name: "flowChart",
  components: {},
  props: {},
  data() {
    return {
      arrowIcon: arrowIcon,
      formatData: [],
      rowData: [],
      fontColor: "#ffffff",
      fontSize: 14,
    };
  },

  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.resetChatData();
  },
  destroyed() {},
  methods: {
    calcArrowClass(index) {
      if ((index + 1) % 2 === 0) {
        return "arrow-left";
      } else if ((index + 1) % 6 < 3) {
        return "arrow-right";
      } else {
        return "arrow-bottom";
      }
    },
    resetChatData() {
      let list = [];
      const res = [];
      this.rowData.forEach((item, index) => {
        if ((index + 1) % 3) {
          list.push(item);
        } else {
          list.push(item);
          res.push([...list]);
          list = [];
        }
      });
      if (list.length) {
        res.push([...list]);
        list = [];
      }
      this.formatData = res;
    },
    updateChart() {
      const { labelShowFontSize } = this.option;
      const {
        chartSet: { seriesLabelSet = {} },
      } = this.themeCfg;
      this.fontSize = labelShowFontSize || seriesLabelSet?.size;
      let { categories = [], series = [] } = this.getDimentionOption();
      series = series.map((item) => {
        return {
          ...item,
          data: item.data.map((dataItem) => {
            const { code } = this.prop.metrics.find(
              (metItem) => metItem.fieldName === item.name
            );
            return dataItem[code] || dataItem;
          }),
        };
      });
      let nameList = [];
      let statusList = [];
      series.find((item) => {
        if (item.name === "排序") {
          const sortData = [...item.data].sort((a, b) => a - b);
          let sortList = [];
          sortData.forEach((it) => {
            sortList.push(item.data.indexOf(it));
          });
          sortList.forEach((idx) => {
            nameList.push(categories[idx]);
            statusList.push(series[0].data[idx]);
          });
        }
      });
      this.rowData = (nameList || []).map((item, index) => {
        return {
          value: item,
          status: statusList[index] * 1,
        };
      });
      this.resetChatData();
      // const { plotOptions, colors } = chart_option;
      // this.progressBgColor = colors[0];
      // this.progressColor = colors[1];
      // this.progressEndColor = colors[2];
      // const optionKey = (Object.keys(plotOptions) || [])[0];
      // const style = plotOptions[optionKey].dataLabels.style || {};
      // this.fontColor = style.color;
      // this.fontSize = style.fontSize ? `${style.fontSize}px` : "";
    },
  },
};
</script>

<style lang="scss" scoped>
.flow-list {
  .flow-subList {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .flow-item {
      display: flex;
      align-items: center;
      flex: 3.7;
      max-width: 37%;
      text-align: center;
      color: #ffffff;
      margin-bottom: 28px;
      .item-select {
        width: 100%;
        height: 28px;
        line-height: 28px;
        background-image: url("@/assets/img/step01.png");
        background-size: 100% 100%;
      }
      .item-normal {
        width: 100%;
        height: 28px;
        line-height: 28px;
        background-image: url("@/assets/img/step02.png");
        background-size: 100% 100%;
      }
      .arrow-item {
        display: flex;
        align-items: center;
        width: 30%;
        .arrow-icon {
          width: 12px;
          height: 12px;
          position: relative;
          left: -6px;
        }
        .arrow-line {
          width: 100%;
          height: 1px;
          background-color: #4cafae;
        }
      }
      .arrow-down {
        display: flex;
        flex-direction: column;
        align-items: center;
        .arrow-icon {
          width: 12px;
          height: 12px;
          transform: rotate(90deg);
          position: relative;
          top: -6px;
        }
        .arrow-line {
          height: 24px;
          width: 1px;
          background-color: #4cafae;
        }
      }
    }
    .flow-down {
      flex: 2.6;
      max-width: 26%;
      position: relative;
      .arrow-down {
        position: absolute;
        left: 50%;
        top: 100%;
        transform: translateX(-50%);
      }
      .item-select {
        width: 100%;
        height: 28px;
        line-height: 28px;
      }
      .item-normal {
        width: 100%;
        height: 28px;
        line-height: 28px;
      }
    }
  }
  .flex-reverse {
    flex-direction: row-reverse;
    justify-content: flex-start;
    .flow-item {
      flex-direction: row-reverse;
      .arrow-item {
        position: relative;
        transform: rotate(180deg);
      }
    }
  }
}
</style>
